import { Moment } from 'moment'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

import Client from '../Client/Client'
import { IExpensesReport } from '../Client/IExpensesReport'

import {
    ActionTypes,
    GET_EXPENSES_REPORT_FAILURE,
    GET_EXPENSES_REPORT_REQUEST,
    GET_EXPENSES_REPORT_SUCCESS,
} from './ActionTypes'
import { IState } from './IState'

export const getExpensesReport = (
    from: Moment,
    to: Moment
): ThunkAction<any, IState, undefined, ActionTypes> => {
    return (dispatch: ThunkDispatch<IState, undefined, any>) => {
        dispatch({
            type: GET_EXPENSES_REPORT_REQUEST,
        })

        return Client.getExpensesReport(from, to).then(
            (surveys: any) => dispatch(getExpensesReportSuccess(surveys)),
            () => {
                dispatch(getExpensesReportFailure())
            }
        )
    }
}

const getExpensesReportSuccess = (report: IExpensesReport[]): ActionTypes => {
    return {
        type: GET_EXPENSES_REPORT_SUCCESS,
        payload: {
            report,
        },
    }
}

const getExpensesReportFailure = (): ActionTypes => {
    return {
        type: GET_EXPENSES_REPORT_FAILURE,
    }
}
